import { type ChangeEvent, useCallback, useEffect, useState } from 'react';

import { clamp, isEmpty, isNotDefined } from '@enterprise/core';

import type { NthInputCellProps } from '@components/nth-calculator/components/types/nth-input-cell.props';

export const useNthInputCellConfiguration = ({ context, data }: Pick<NthInputCellProps, 'context' | 'data'>) => {
  const [localValue, setLocalValue] = useState<string>(data?.nthValue?.toString() ?? '');

  const handleBlur = () => {
    if (isNotDefined(data)) {
      return;
    }

    if (isEmpty(localValue)) {
      context.handleRowUpdate(data.mailingListId, {
        nthValue: null,
        selectedTwentileValues: [],
      });

      return;
    }

    const parsed = Number.parseFloat(localValue);

    if (!Number.isFinite(parsed)) {
      context.handleRowUpdate(data.mailingListId, { nthValue: null, selectedTwentileValues: [] });

      return;
    }

    const clamped = clamp(parsed, 0, data.firstOutput);

    context.handleRowUpdate(data.mailingListId, {
      nthValue: clamped,
      selectedTwentileValues: [],
    });
  };

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setLocalValue(e.target.value);
  }, []);

  const handleClear = () => {
    if (isNotDefined(data)) {
      return;
    }

    setLocalValue('');
    context.handleRowUpdate(data.mailingListId, { nthValue: null, selectedTwentileValues: [] });
  };

  useEffect(() => {
    setLocalValue(data?.nthValue?.toString() ?? '');
  }, [data?.nthValue]);

  return { handleBlur, handleChange, handleClear, localValue };
};
